import React from 'react'
import { Stack, ThemeProvider } from '@rebeldotcom/components'
import {
  ErrorBoundary,
  SearchAndAddOnsPage,
  isInternic,
  VulcanThemeProvider,
} from '@rebeldotcom/ui'
import Layout from '../../components/layout'

export default function SearchNew() {
  return (
    <Layout location="new-search-page">
      <ThemeProvider>
        <ErrorBoundary location="new-page">
          <Stack
            alignItems="center"
            id="Search-Page-Wrapper"
            justifyContent="center"
            minHeight="80vh"
            width="100%"
          >
            <VulcanThemeProvider isInternic={isInternic}>
              <SearchAndAddOnsPage />
            </VulcanThemeProvider>
          </Stack>
        </ErrorBoundary>
      </ThemeProvider>
    </Layout>
  )
}
